// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16UpM","toggle":"styles_toggle__qI4hk","preview":"styles_preview__IjP7H"};